import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './theme/base.css';

const root = document.getElementById('root');
if (!root) throw new Error('missing #root — index.html was not served');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
